module.exports = __webpack_public_path__ + "static/media/marcasFerreteria.72706f4f.jpg";